import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EditableGlobal } from '../model/global.interface';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalsService {
  private URL: string;
  private headers: HttpHeaders;

  constructor(@Inject(ConfigService) private config: any, private http: HttpClient) {
    // Use the same pattern as other services
    this.URL = config.REST_SERVER_HOST + '/api/amassapp';
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
    console.log('GlobalsService initialized with URL:', this.URL);
  }

  // Get all globals from the API
  getGlobals(): Observable<any> {
    // Based on the pattern from other services, try the most likely endpoint
    const endpoint = `${this.URL}/glb/globals`;
    console.log('Making API call to:', endpoint);
    
    // Use the same pattern as other services - DoNotIntercept bypasses cache interceptor
    const headers = this.headers;
    
    return this.http.get(endpoint, { 
      headers: headers
    });
  }

  // Update globals (for future implementation)
  updateGlobals(globals: EditableGlobal[]): Observable<any> {
    const endpoint = `${this.URL}/globals`;
    console.log('Updating globals at:', endpoint);
    
    const headers = this.headers;
    
    return this.http.put(endpoint, globals, { 
      headers: headers
    });
  }

  // Set globals using GLB endpoint
  setGlobals(payload: any): Observable<any> {
    const endpoint = `${this.URL}/glb/setglobals`;
    console.log('Setting globals at:', endpoint, 'with payload:', payload);
    const headers = this.headers;
    return this.http.post(endpoint, payload, { headers });
  }
}
